import { getMenuRoutes } from '@/api/permission';
import { addDynamicRoutes } from '@/router';

const state = {
  menus: [],          // 原始菜单树（用于侧边栏渲染）
  asyncRoutes: [],    // 生成后的路由配置（用于调试）
  menusLoaded: false, // 是否已加载菜单
  permissions: []     // 当前页面的按钮权限（由路由切换更新）
};

const mutations = {
  SET_MENUS(state, menus) {
    state.menus = menus;
  },
  SET_ASYNC_ROUTES(state, routes) {
    state.asyncRoutes = routes;
  },
  SET_MENUS_LOADED(state, loaded) {
    state.menusLoaded = loaded;
  },
  SET_PAGE_PERMISSIONS(state, perms) {
    state.permissions = perms;
  }
};

const actions = {
  // 加载菜单并动态添加路由
  async loadMenus({ commit }) {
    const res = await getMenuRoutes();
    if (res.code === 200) {
      const menus = res.data || [];
      addDynamicRoutes(menus); // 内部会 commit SET_MENUS, SET_ASYNC_ROUTES, SET_MENUS_LOADED
      return menus;
    } else {
      throw new Error(res.message || '获取菜单失败');
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};